import { render, staticRenderFns } from "./searchResult.vue?vue&type=template&id=2001405d&scoped=true"
import script from "./searchResult.vue?vue&type=script&lang=js"
export * from "./searchResult.vue?vue&type=script&lang=js"
import style0 from "./searchResult.vue?vue&type=style&index=0&id=2001405d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2001405d",
  null
  
)

export default component.exports